const fontFamily = [
    'arial',
    'verdana',
    'tahoma'
]

export default fontFamily;